export const ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD = 'ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD'
export const ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD_PENDING =
  'ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD_PENDING'
export const ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD_FULFILLED =
  'ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD_FULFILLED'
export const ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD_REJECTED =
  'ATTENDANCE_ANALYTICS_ABSENCE_RATE_LOAD_REJECTED'

export const SET_ABSENCE_RATE_FILTERS = 'SET_ABSENCE_RATE_FILTERS'
